/**
 * Roles del usuario identificado.
 *
 * El login guarda en `localStorage` la cadena `superadmin` cuando el usuario
 * tiene ese rol y, en el resto de casos, el array de roles serializado
 * (`["comercial"]`). Estas ayudas normalizan ambas formas.
 */
export const getUserRoles = () => {
  const raw = localStorage.getItem('role')
  if (!raw) return []

  try {
    const parsed = JSON.parse(raw)
    if (Array.isArray(parsed)) {
      return parsed.map((role) => String(role?.name ?? role)).filter(Boolean)
    }

    return [String(parsed)].filter(Boolean)
  } catch {
    return [raw]
  }
}

export const hasAnyRole = (roles = []) => {
  const current = getUserRoles()
  return roles.some((role) => current.includes(role))
}

/**
 * Perfiles internos de ADS, alineados con User::isAdsUser() en la API.
 * El resto (horizontal, vertical, both, worker) son cuentas de cliente.
 */
export const isAdsUser = () => hasAnyRole(['superadmin', 'admin', 'comercial'])

/**
 * Quien gestiona solicitudes en ADS, igual que User::isAdsManager() en la API:
 * el responsable y Back Office. Se reparten el trabajo entre ellos, así que
 * pueden asignar y reasignar cualquier solicitud (ADS-0126).
 */
export const isAdsManager = () => hasAnyRole(['superadmin', 'admin'])

/**
 * Gestor de Back Office, igual que User::isBackOffice() en la API: ve la
 * plataforma entera, pero su trabajo son las solicitudes que tiene asignadas,
 * y por eso su Inicio resume y abre solo esas (ADS-0113).
 */
export const isBackOffice = () => hasAnyRole(['admin']) && !hasAnyRole(['superadmin'])
